import React from 'react';
import { Helmet } from 'react-helmet';

import NavigationBar from '../NavigationBar';
import Footer from '../Footer';
import { useTranslation } from '../../i18n';

// Thin page: the canonical security model (threat model, storage table, data
// format spec) lives on the marketing site so it exists in one place.
const Security = () => {
  const { t, lang } = useTranslation();
  const url = lang === 'pl'
    ? 'https://securepaper.app/pl/security'
    : 'https://securepaper.app/security';

  return (
    <>
      <Helmet>
        <title>Security Model - SecurePaper</title>
        <meta name="description" content="Exactly how SecurePaper protects your data: client-side AES-256-GCM encryption, what is stored where, the full data format, and an offline decryptor." />
        <link rel="canonical" href="https://securepaper.app/security" />
      </Helmet>
      <NavigationBar />

      <div className="container">
        <div className="py-5 text-center" style={{ minHeight: '50vh' }}>
          <h1>{t('legal.securityTitle')}</h1>
          <p className="text-muted mx-auto mt-3" style={{ maxWidth: '620px' }}>
            {t('legal.securityNote')}
          </p>
          <div className="mt-3">
            <a href={url} className="btn btn-primary mr-2">
              <i className="fa fa-arrow-up-right-from-square mr-2" aria-hidden="true"></i>
              {t('legal.openFull')}
            </a>
            <a href="/offline-decryptor.html" download className="btn btn-outline-primary">
              <i className="fa fa-download mr-2" aria-hidden="true"></i>
              {t('footer.offlineDecryptor')}
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Security;
